import React from 'react';

// Shown when the central hub reports this tenant's server is disabled.
// Surfaced by AuthContext: any /api/* response of 423 server_disabled
// (or a /api/server-status poll returning enabled:false) sets state on
// the auth context, which App.js then renders this component for.
//
// Payload shape mirrors the server's /api/server-status response:
//   { enabled: false, message, portalUrl, reason }
export default function DisabledScreen({ message, portalUrl, reason }) {
  const hub = portalUrl || 'https://mikesapphub.com';
  return (
    <div style={{
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      background: '#070b14', color: '#e2e8f0', minHeight: '100vh',
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24,
    }}>
      <div style={{
        background: '#0e1525', border: '1px solid rgba(220,38,38,0.25)',
        borderRadius: 20, padding: '48px 40px', maxWidth: 480, width: '100%',
        boxShadow: '0 32px 80px rgba(0,0,0,0.6)', textAlign: 'center',
      }}>
        <div style={{
          width: 64, height: 64, borderRadius: '50%',
          background: 'rgba(220,38,38,0.12)',
          display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
          marginBottom: 20, fontSize: 32,
        }}>⛔</div>
        <h1 style={{ fontSize: 22, fontWeight: 800, color: '#fca5a5', marginBottom: 12 }}>
          {message || 'This server has been disabled'}
        </h1>
        <p style={{ color: '#cbd5e1', fontSize: 14, lineHeight: 1.7, marginBottom: 14 }}>
          Please check your customer portal by clicking{' '}
          <a href={hub} target="_blank" rel="noopener noreferrer" style={{ color: '#60a5fa', fontWeight: 600 }}>here</a>.
        </p>
        {reason && (
          <div style={{
            background: '#0a0f1a', border: '1px solid #1e293b',
            borderLeft: '3px solid #dc2626', borderRadius: 8,
            padding: '12px 16px', fontSize: 13, color: '#94a3b8',
            textAlign: 'left', margin: '18px 0',
          }}>
            <strong style={{ color: '#cbd5e1', display: 'block', marginBottom: 4, fontSize: 11, textTransform: 'uppercase', letterSpacing: '0.8px' }}>Reason</strong>
            {reason}
          </div>
        )}
        <a href={hub} target="_blank" rel="noopener noreferrer" style={{
          display: 'inline-block',
          background: 'linear-gradient(135deg,#2563eb,#3b82f6)',
          color: '#fff', textDecoration: 'none',
          padding: '13px 30px', borderRadius: 10,
          fontWeight: 700, fontSize: 14, marginTop: 8,
        }}>
          Open Mikes App Hub →
        </a>
      </div>
    </div>
  );
}
